import Label from "Components/Common/components/Label";
import React, { useEffect, useState } from "react";
import { TABSConstraintsWithoutValues, TABSValueConstriant } from "../types";
import ViewMoreButton from "Components/Common/components/ViewMoreButton";
import CustomSearchBar from "Components/GMS/Products/components/CustomSearchBar";

type MyProps = {
    absDetails: TABSConstraintsWithoutValues,
    setAbsDetails: React.Dispatch<React.SetStateAction<TABSConstraintsWithoutValues|null>>,
    attributeValuesCount: number,
    fetchAbsConstraints: (search?: string, skip?: number, reset?: boolean) => Promise<void>,
    valueConstraints: TABSValueConstriant[]
    setValueConstraints: React.Dispatch<React.SetStateAction<TABSValueConstriant[]>>
    search?: string
    setSearch: React.Dispatch<React.SetStateAction<string|undefined>>
    hasClickedABSToggle: boolean
    setHasClickedABSToggle: React.Dispatch<React.SetStateAction<boolean>>
}

export default function EditABS({ 
    absDetails, 
    setAbsDetails,
    attributeValuesCount,
    fetchAbsConstraints,
    valueConstraints,
    setValueConstraints,
    search,
    setSearch,
    hasClickedABSToggle,
    setHasClickedABSToggle
}: MyProps) {
    const VALUE = "value";
    const DISPLAY_VALUE = "displayValue";
    const IMAGE = "image";
  
    const [absProp, setAbsProp] = useState(
      absDetails && absDetails.abs_properties
    );
  
    useEffect(() => {
      absDetails && setAbsProp(absDetails.abs_properties);
    }, [absDetails]);
  
    function getBool(val: string|boolean) {
      return !!JSON.parse(String(val).toLowerCase());
    }
  
    useEffect(() => {
      if (absDetails.abs_properties) {
        if (absProp.displaySearch === null || undefined) {
          setAbsProp((prevState) => ({
            ...prevState,
            displaySearch: false,
          }));
        }
        if (absProp.valuesPerRow === null || undefined) {
          setAbsProp((prevState) => ({
            ...prevState,
            valuesPerRow: 1,
          }));
        }
        if (absProp.maxHeight === null || undefined) {
          setAbsProp((prevState) => ({
            ...prevState,
            maxHeight: "Not Set",
          }));
        }
        if (absProp.DisplayType === null || undefined) {
          setAbsProp((prevState) => ({
            ...prevState,
            DisplayType: "value",
          }));
        }
      }
      setAbsDetails((prev) => ({
        ...(prev as TABSConstraintsWithoutValues),
        abs_properties: absProp,
      }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [absProp]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>, value: string|boolean|number) => {
      let field = e.target.name;
      setAbsProp((prevState) => ({
        ...prevState,
        [field]: value,
      }));
    };
    const handleChecked = (e: React.ChangeEvent<HTMLInputElement>, value: string|boolean, isAbsEnable?: boolean) => {
      let field = e.target.name;
      if(!hasClickedABSToggle) setHasClickedABSToggle(true)
      setAbsDetails((prevState) => {
				const nextState = {
						...(prevState as TABSConstraintsWithoutValues),
						[field]: value,
				}

				if(isAbsEnable) nextState['abs_enable_changed'] = true

				return nextState
			});
    };
  
    useEffect(() => {
      const isAnyAbsShowTrue = valueConstraints.some(
        (singleValue) => singleValue.abs_show
      );
      
      if (absDetails.abs_enabled) {
        if (!isAnyAbsShowTrue) {
            setValueConstraints((prev) => {
              const updatedValueConstraints = [...prev].map(
                (singleValue) => {
                  return { ...singleValue, abs_show: true };
                }
            );
            return updatedValueConstraints
          });
        }
      } else {
        if (isAnyAbsShowTrue) {
            setValueConstraints((prev) => {
              const updatedValueConstraints = [...prev].map(
                (singleValue) => {
                  return { ...singleValue, abs_show: false };
                }
            );
            return updatedValueConstraints
          });
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [absDetails?.abs_enabled]);
  
    function handleValue(e: React.ChangeEvent<HTMLInputElement>, value: boolean|string, index: number) {
      let arr = [...valueConstraints];
      let obj = { ...arr[index] };
      obj = { ...obj, [e.target.name]: value, changed: true };
      arr.splice(index, 1, obj);
      setValueConstraints(arr)
    }
  
    function handleImage(e: React.ChangeEvent<HTMLInputElement>, value: string, index: number, isValidUrl: boolean) {
      let arr = [...valueConstraints];
      let obj = { ...arr[index] };
      obj = { ...obj, [e.target.name]: value, isValidUrl: isValidUrl, changed: true };
      arr.splice(index, 1, obj);
      setValueConstraints(arr)
    }
  
    const validURL = (str: string) => {
      if (str == null || undefined || "" || str.length === 0) {
        return true;
      }
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
  
      if (url.protocol === "http:" || url.protocol === "https:") {
        let pattern = new RegExp(
          "^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
          "i"
        ); // fragment locator
        return !!pattern.test(str);
      }
    };
  
    return (
      <>
        {absProp && (
          <>
            <div className="form-check form-switch">
              <input
                className="shadow-none form-check-input"
                type="checkbox"
                name="abs_enabled"
                id="flexSwitchCheckChecked"
                onChange={(e) => handleChecked(e, !absDetails.abs_enabled, true)}
                checked={getBool(absDetails.abs_enabled)}
                value={`${absDetails.abs_enabled ?? true}`}
              />
              <Label
                message="Activate this attribute for ABS"
                fontSize={"0.8"}
                htmlFor="flexSwitchCheckChecked"
              />
            </div>
            <div className="mr-2 form-check form-switch">
              <input
                className="shadow-none form-check-input"
                type="checkbox"
                disabled={!absDetails.abs_enabled}
                name="displaySearch"
                id="name"
                checked={getBool(absProp?.displaySearch ?? false)}
                value={`${absDetails.displaySearch}`}
                onChange={(e) => handleChange(e, !getBool(absProp?.displaySearch ?? false))}
              />
              <Label message="Display Search?" fontSize={"0.8"} htmlFor="name" />
              {/* <label className="form-check-label" htmlFor="name">
                Display Search?
              </label> */}
            </div>
  
            <div className="mt-3 mb-3">
              <Label message="Display Name" fontSize={"0.8"} htmlFor="name" />
              {/* <label htmlFor="floatingInput" className="mb-2">
                Display Name
              </label> */}
              <input
                type="text"
                style={{ fontWeight: "600", fontSize: ".8rem" }}
                className="shadow-none form-control"
                id="floatingInput"
                name="displayName"
                disabled={!absDetails.abs_enabled}
                value={absProp.displayName}
                placeholder="name"
                onChange={(e) => handleChange(e, e.target.value)}
              />
            </div>
            <div className="d-flex justify-content-between">
              <div className="w-25">
                <Label message="Display Type" fontSize={"0.8"} />
                {/* <label htmlFor="floatingInput">Display Type</label> */}
                <select
                  className="mt-2 shadow-none form-select form-select-sm"
                  aria-label=".form-select-sm example"
                  disabled={!absDetails.abs_enabled}
                  name="DisplayType"
                  style={{ fontSize: ".8rem", fontWeight: "600" }}
                  onChange={(e) => handleChange(e, e.target.value)}
                  value={absProp.DisplayType}
                >
                  <option value={VALUE}>No</option>
                  <option value={DISPLAY_VALUE}>Yes, Text</option>
                  <option value={IMAGE}>Yes, Images</option>
                </select>
              </div>
  
              <div className="w-25">
                <Label message="Values Per Row" fontSize={"0.8"} />
                {/* <label htmlFor="floatingInput">Values Per Row</label> */}
                <select
                  className="mt-2 shadow-none form-select form-select-sm"
                  aria-label=".form-select-sm example"
                  name="valuesPerRow"
                  disabled={!absDetails.abs_enabled}
                  style={{ fontSize: ".8rem", fontWeight: "600" }}
                  onChange={(e) => handleChange(e, parseInt(e.target.value))}
                  value={absProp.valuesPerRow}
                >
                  <option value={1}>One Value</option>
                  <option value={2}>Two Values</option>
                  <option value={3}>Three Values</option>
                  <option value={4}>Four Values</option>
                  <option value={5}>Five Values</option>
                </select>
              </div>
              <div className="w-25">
                {/* <label htmlFor="floatingInput"> Max Height</label> */}
                <Label message="Max Height" fontSize={"0.8"} />
                <select
                  className="mt-2 shadow-none form-select form-select-sm"
                  aria-label=".form-select-sm example"
                  name="maxHeight"
                  disabled={!absDetails.abs_enabled}
                  style={{ fontSize: ".8rem", fontWeight: "600" }}
                  onChange={(e) => handleChange(e, e.target.value)}
                  value={absProp.maxHeight}
                >
                  <option value="Not Set">Not Set</option>
                  <option value="Small">Small</option>
                  <option value="Medium">Medium</option>
                  <option value="Large">Large</option>
                </select>
              </div>
            </div>

            <div className="tw-pt-2">
                <div className="tw-w-60 ">
                    <CustomSearchBar 
                        placeholder="Search Attribute Values"
                        handleSearchChange = {setSearch}
                        value={search}
                    />
                </div>
            </div>
  
            {valueConstraints &&
              valueConstraints.length > 0 && (
                <>
                  <table className="table mt-4 table-sm table-borderless">
                    <thead>
                      <tr className="mb-5">
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          Display
                        </th>
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          Value
                        </th>
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          ABS Display Value
                        </th>
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          ABS Image Url
                        </th>
                        <th scope="col" style={{ fontSize: ".8rem" }}>
                          ABS Alt text
                        </th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {valueConstraints?.map((singleValue, index) => {
                        return (
                          <tr key={index}>
                            <td style={{ width: "10%" }}>
                              <div className="mt-2 mb-3 mr-2 align-middle form-check form-switch">
                                <input
                                  className="shadow-none form-check-input"
                                  type="checkbox"
                                  name="abs_show"
                                  disabled={!absDetails.abs_enabled}
                                  id={`${index}`}
                                  checked={getBool(singleValue.abs_show)}
                                  value={`${getBool(singleValue.abs_show)}`}
                                  onChange={(e) =>
                                    handleValue(
                                      e,
                                      !getBool(singleValue.abs_show),
                                      index
                                    )
                                  }
                                />
                              </div>
                            </td>
  
                            <td style={{ fontSize: ".8rem", fontWeight: "600" }}>
                              {singleValue.value}
                            </td>
  
                            <td className="mb-2">
                              <input
                                type="text"
                                className="shadow-none form-control"
                                style={{
                                  padding: "1",
                                  fontSize: ".875rem",
                                  fontWeight: "500",
                                }}
                                name="abs_display_value"
                                disabled={!absDetails.abs_enabled}
                                value={singleValue.abs_display_value}
                                placeholder="ABS Display value"
                                onChange={(e) =>
                                  handleValue(e, e.target.value, index)
                                }
                              />
                            </td>
  
                            <td className="mb-2">
                              <input
                                type="text"
                                className="shadow-none form-control"
                                name="abs_image_url"
                                style={{
                                  padding: "1",
                                  fontSize: ".8rem",
                                  fontWeight: "600",
                                }}
                                value={singleValue.abs_image_url}
                                disabled={!absDetails.abs_enabled}
                                placeholder="ABS Image Url starts with https:// or http://"
                                onChange={(e) => {
                                  if (
                                    validURL(e.target.value) ||
                                    e.target.value === ""
                                  ) {
                                    e.target.className = "form-control";
                                    handleImage(e, e.target.value, index, true);
                                  } else {
                                    handleImage(e, e.target.value, index, false);
                                    e.target.className =
                                      "form-control is-invalid";
                                  }
                                }}
                              />
                            </td>
                            <td className="mb-2">
                              <input
                                type="text"
                                className="shadow-none form-control"
                                style={{
                                  padding: "1",
                                  fontSize: ".8rem",
                                  fontWeight: "600",
                                }}
                                name="abs_alt_text"
                                disabled={!absDetails.abs_enabled}
                                value={singleValue.abs_alt_text}
                                placeholder="ABS Alt text"
                                onChange={(e) =>
                                  handleValue(e, e.target.value, index)
                                }
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  <ViewMoreButton
                    condition = {valueConstraints.length < attributeValuesCount}
                    state = {valueConstraints.length >= attributeValuesCount}
                    handleClick = {() => fetchAbsConstraints(search, valueConstraints.length)}
                    />
                </>
              )}
          </>
        )}
      </>
    );
  }
  